import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
  }

  .radio-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-md, 16px);
    cursor: pointer;
  }

  
  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .radio {
    width: 24px;
    height: 24px;
    border-radius: 12px; /* Fully circular */
    box-sizing: border-box;
    position: relative;
    flex: none;
    transition: all 0.2s ease-in-out;
  }

  .label {
    font-size: var(--font-size-b1, 16px);
    line-height: var(--line-height-b1, 24px);
    font-weight: var(--font-weight-regular, 400);
    color: var(--on-surface, #131927);
  }

  :host([position="right"]) .label {
    text-align: right;
  }

  .dot {
  	position: absolute;
  	width: 12px;
  	height: 12px;
  	top: 50%;
  	left: 50%;
  	transform: translate(-50%, -50%);
  	background: var(--color-secondary, #2594E3);
  	border-radius: 50%;
	}
  
	/* States */
  :host([state="default"]) .radio {
    border: var(--sm-line, 1.5px) solid var(--color-primary-dark, #001D68);
  }

  :host([state="hover"]) .radio {
    background: var(--surface-raised, #FFFFFF);
    border: var(--sm-line, 1.5px) solid var(--color-secondary, #2594E3);
  }

  :host([state="focus"]) .radio {
    background: var(--surface-raised, #FFFFFF);
    border: var(--sm-line, 1.5px) solid var(--color-secondary, #2594E3);
    box-shadow: var(--shadow-focus);
  }

  :host([state="selected"]) .radio {
    border: var(--sm-line, 1.5px) solid var(--color-secondary, #2594E3);
  }

  :host([state="disabled"]) .radio {
    border: var(--sm-line, 1.5px) solid var(--color-gray-2, #E5E7EA);
  }

  :host([state="disabled"]) .label {
    color: var(--color-gray-3, #D7D4D2);
  }

  :host([disabled]) .radio-wrapper {
    cursor: not-allowed;
  }
`;
